<button color="primary" type="button" mat-fab matTooltip="Add new" [routerLink]="link">
  <mat-icon>add</mat-icon>
</button>
